import api from './client';

const BASE = '/api/settings/company';

/**
 * Get company details (name, logo, address, phone, email, taxId).
 * @param {Object} config - Optional axios config (e.g. { headers: { Authorization } }).
 */
export async function getCompany(config = {}) {
  const { data } = await api.get(BASE, config);
  return data;
}

/**
 * Update company details.
 */
export async function updateCompany(payload, config = {}) {
  const { data } = await api.put(BASE, payload, config);
  return data;
}
